// src/tracker/components/SpendingPieChart.js

import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SpendingPieChart = ({ data }) => {
    const theme = useTheme();
    const colors = [
        theme.palette.primary.main,
        theme.palette.success.main,
        theme.palette.warning.main,
        theme.palette.error.main,
        theme.palette.secondary.main,
    ];
    const phpSymbol = '₱';

    if (!data || data.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography color="text.secondary">No spending data for this month.</Typography>
            </Box>
        );
    }
    
    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="value"
                    label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                </Pie>
                <Tooltip
                    formatter={(value) => `${phpSymbol}${Number(value).toLocaleString()}`}
                    contentStyle={{
                        backgroundColor: theme.palette.mode === 'dark' ? '#0f172a' : '#ffffff',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 8,
                        color: theme.palette.text.primary,
                    }}
                    labelStyle={{ color: theme.palette.text.secondary }}
                />
                <Legend wrapperStyle={{ color: theme.palette.text.secondary }} />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default SpendingPieChart;
